import React, { useState, useEffect } from "react";
import { Button, CheckBox } from "../../../common/commonIndex";
const HealthConditionsPage = ({ handleNextEvent, formData, questionData }) => {
    const [diagnosedWith, setDiagnosedWith] = useState(formData?.answer || []);
    const [isValid, setIsValid] = useState(false);
    useEffect(() => {
        if (formData?.answer) {
            setDiagnosedWith(formData?.answer);
            setIsValid(true);
        } else {
            setDiagnosedWith([]);  // Empty array for no initial selections
            setIsValid(false);
        }
    }, [formData]);  // Dependency array to only run effect when formData changes

    useEffect(() => {
        formData.answer = diagnosedWith;
        let matchingIds = questionData?.listOfAnswers?.filter(answerObj => formData?.answer?.includes(answerObj.answer))?.map(answerObj => answerObj.id);
        formData.fkAnswerIds = matchingIds;
        console.log('formData', formData);
    }, [diagnosedWith])

    /* Callback function to handle checkbox change */
    const handleRadioChange = (value) => {
        if (value.toLowerCase() === 'none') {
            setDiagnosedWith([value]);
        } else {
            let findData = diagnosedWith?.filter(x => x !== 'None')
            if (findData?.includes(value)) {
                // If value is already selected, remove it from the array
                setDiagnosedWith(findData?.filter(item => item !== value));
            } else {
                // Otherwise, add the value to the array
                setDiagnosedWith([...findData, value]);
            }
        }
        setIsValid(true);  // Enable the continue button once something is selected
    };
    /* Submit */
    const handleSubmit = (e) => {
        // skip then 2 otherwise 1
        let skip = 1;
        // if (questionData?.skippedNestedQuestionID) {
        //     skip = 2;
        // }
        const findData = getLocalStorageData();
        findData[questionData.questionerIndex] = formData;
        setLocalStorageData(findData);
        handleNextEvent(questionData?.questionerIndex + skip);
    };

    const getLocalStorageData = () => {
        const findlocalStorageData = JSON.parse(localStorage.getItem('listOfAnswer'));
        return findlocalStorageData;
    }
    const setLocalStorageData = (data) => {
        if (data?.length > 0) {
            localStorage.setItem('listOfAnswer', JSON.stringify(data));
        }
    }
    return (
        <>
            <div className="email-form-container">
                <h2 className="title" style={{ marginBottom: window.innerWidth ? 480 > '52px' : '22px' }}>{questionData?.question}</h2>
                <div className="scrollbar conditions-scrollbar">
                    <div className="force-overflow">
                        <form>
                            <div className="checkbox mb-md-5 conditions-checkbox">
                                {questionData?.listOfAnswers?.map((item, index) => {
                                    const isSelected = diagnosedWith.includes(item?.answer);
                                    const className = isSelected ? "checkbox-item " : "checkbox-item ";
                                    return (
                                        <div className={'checkbox-item'} key={index}>
                                            <CheckBox
                                                checkBox="gender"
                                                name={item?.answer}
                                                id={index}
                                                onCheckBoxChange={handleRadioChange}
                                                formData={formData}
                                                value={diagnosedWith}
                                                setValue={setDiagnosedWith}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="questionnaire-fix-btn eligibility-fix-btn">
                <div className="divider "></div>
                <div className="footer-content">
                    <div className="skip-eligibility">
                    </div>
                    <Button
                        btnClass={'btn-primary question-btn'}
                        btnType={'button'}
                        btnName={'Continue'}
                        onClick={handleSubmit}
                        isDisabled={isValid}
                    />
                </div>
            </div>
        </>
    )
};

export default HealthConditionsPage;